let sidebar = new FilterSidebar("#filterSidebar");

sidebar.$el.find(".FilterSidebar_reset").on("click", (event) => {
  event.preventDefault();
  filter.resetFilterForm();
  CorpusSchemeTrigger.reset();
});

$(".FilterMobileSwitcher").selectmenu({
  change: (event, ui) => {
    window.location.href = ui.item.value;
  },
});

$(".PanelBtn-filter").on("click", function () {
  $(".FilterPage_overlay").toggleClass("FilterPage_overlay-active");
  $("body").toggleClass("scroll-lock");
  sidebar.toggle();
});

$(".FilterPage_overlay, .FilterSidebar_close, .FilterForm_btn-search").on(
  "click",
  function () {
    $(".FilterPage_overlay").removeClass("FilterPage_overlay-active");
    $("body").toggleClass("scroll-lock");
    sidebar.toggle();
  }
);

let cardTplStr = `
<% 
  let promoCardsOrders = [];
  promos.forEach(function(promoCard){
	promoCardsOrders.push(promoCard.order - 1);
  });

  var eachFlatCardIteration = 0;

%>
<% _.forEach(plans, function(group, rooms) { %>
<h4 class="CardsList_groupTitle">

		<% if(rooms == 0){%>
			Студия
		<% } else{ %>
			<%= rooms %> <%= declOfNum(rooms, ['комната','комнаты','комнат']) %>
		<% }; %>
		: <%= group.length %> <%= declOfNum(group.length, ['тип','типа','типов']) %>
		
	</h4>
<div class="CardsList_groupList">
	<% _.forEach(group, function(card, index) { %>
		<% if(_.includes(promoCardsOrders, eachFlatCardIteration)){ %>
			<% let promo = promos.shift();%>
			<% if (!promo.specialOffer) { %>
				<div class="FlatCard FlatCard-promo">
					<div class="FlatCard_promoInner">
						<div class="FlatCard_discountVal">
							<%= promo.headTopText %>
						</div>
						<h6 class="FlatCard_promoHead"><%= promo.title %></h6>
						<div class="FlatCard_promoText">
							<%= promo.desc %>
						</div><a class="Btn Btn-color3 Btn-size2" href="<%= promo.link %>">Узнать подробнее</a>
					</div>
				</div>
			<% } else { %>
				<a class="FlatCard FlatCard-specialOffer" href="<%= promo.url %>">
					<div class="FlatCard_content">
						<%= promo.desc %>
					</div>

					<span class="MoreBtn FlatCard_specialBtn">Подробнее</span>
				</a>
			<% }; %>
			<% eachFlatCardIteration++ %>
		<% }; %>
		<% let plan = card; %>
			<a class="FlatCard" href="<%= plan.href %>">
				<div class="FlatCard_head"> Тип <b class="FlatCard_headName"><%= plan.name %></b></div>
				<div class="FlatCard_content">
					<div class="FlatCard_schemeWrap"><img class="FlatCard_scheme" src="<%= plan.plan %>" alt=""></div>
					<div class="FlatCard_paramsWrap">
						<table class="FlatCard_paramsTbl">
							<tbody>
								<tr class="FlatCard_paramsRow">
									<td class="FlatCard_paramsCell"><span class="FlatCard_paramsLabel">площадь от</span></td>
									<td class="FlatCard_paramsCell"><span class="FlatCard_paramsLabel"></span></td>
									<td class="FlatCard_paramsCell"><span class="FlatCard_paramsLabel"></span></td>
									<td class="FlatCard_paramsCell"><span class="FlatCard_paramsLabel">цена от</span></td>
								</tr>
								<tr class="FlatCard_paramsRow">
									<td class="FlatCard_paramsCell"><span class="FlatCard_paramsVal"><%= plan.areaMin %> м<sup>2<sup/></span></td>
									
									<td class="FlatCard_paramsCell"><span class="FlatCard_paramsVal"></span></td>

									<td class="FlatCard_paramsCell"><span class="FlatCard_paramsVal"></span></td>

									<td class="FlatCard_paramsCell"><span class="FlatCard_paramsVal"> <%= (FShowPrices) ? ( plan.priceMin + ' ₽' ) : 'По запросу' %> </span></td>

								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</a>
		
		<% eachFlatCardIteration++ %>
	<% }); %>
</div>
<% }); %>
`;

let plansListBuilder = new CardsList({
  tpl: cardTplStr,
  additionalClassName: "CardsList-flatPlans",
});

//ranges dinamic

function updateRanges(ranges) {
  $.each(ranges, (key, val) => {
    let slider = document.getElementById("range-" + key);
    let $slider = $(slider);
    let $inputs = $slider.find("input");
    let $key = key;

    let $ranges = filter.getRangeSliders();

    $.each($ranges, function (key, value) {
      if (value.$track.parent().attr("id") == "range-" + $key) {
        value.$track.parent().data("dinamicrange", "true");
        value.renderValuesToCounterEl([parseInt(val[0]), parseInt(val[1])]);
        value.$track.slider("values", [parseInt(val[0]), parseInt(val[1])]);
        value.$track.parent().data("dinamicrange", "false");
      }
    });
  });
}

let sliderID;
let checkboxID;
let resetChecksInf = false;

$(".FilterForm").on("change", "input", function (e) {
  let $target = $(e.target);
  let name = $target.attr("name");
  resetChecksInf = false;
  if (
    name == "bedrooms[]" ||
    name == "corpus[]" ||
    name == "quarters[]" ||
    name == "promo" ||
    name == "finish"
  ) {
    resetChecksInf = true;
  }

  if ($target.is(":checkbox")) {
    checkboxID = $target.attr("name");
  } else {
    checkboxID = undefined;
  }

  if ($target.closest(".RangeSlider").length) {
    sliderID = $target.closest(".RangeSlider").attr("id");
  } else {
    sliderID = undefined;
  }
});

$(".RangeSlider").on("change", (e) => {
  $(".RangeSlider").removeClass("_last");
  $(e.currentTarget).addClass("_last");
});

let filter = new FilterForm("#filterForm", {
  submitHandler: ($filterForm) => {
    // console.log(" --- submitHandler fired---");
    let currentFiltersParams = $filterForm.serializeObject();
    let lastSlider = $(".RangeSlider").filter("._last").attr("id");

    $.extend(true, currentFiltersParams, {
      current_control: typeof sliderID != "undefined" ? sliderID : "",
      last_control: typeof lastSlider != "undefined" ? lastSlider : "",
    });

    let dataSendValues = [
      "floor_from",
      "floor_to",
      "price_from",
      "price_to",
      "area_from",
      "area_to",
    ];

    if (resetChecksInf) {
      let lastSliderType =
        lastSlider == undefined
          ? "undefined"
          : lastSlider.replace("range-", "");

      $(dataSendValues).each((i, e) => {
        if (e.indexOf(lastSliderType) != 0) {
          delete dataToSend[e];
        }
      });
    }

    $.ajax({
      url: $filterForm.attr("action") || $filterForm.data("action"),
      dataType: "json",
      method: "GET",
      data: currentFiltersParams,
      beforeSend: () => {
        $("body").addClass("_loading");
      },
    })
      .done((jsonResponse) => {
        setTimeout(() => {
          $("body").removeClass("_loading");
        }, 1000);
        // parse filters params to object
        console.log(currentFiltersParams);

        updateRanges(jsonResponse.ranges);

        if (jsonResponse.pantry_ids) {
          console.log(jsonResponse);
          console.log("pantry flats..");
          var ids = jsonResponse.pantry_ids;
          $(".EstScheme_link, .BldScheme_link, .HouseSection_mobileCard").each(function() {
            var flat_id = parseInt($(this).attr("flat_id"));

            if (ids.indexOf(flat_id) >= 0) {
              $(this).show();
            } else $(this).hide();
          });
        } else if (jsonResponse.floor_num) {
          console.log("floor ..");
          var ids = jsonResponse.floor_num;
          var floor_cnt = jsonResponse.floor_cnt;

          console.log(floor_cnt);

          $(".Genplan_poligonLink ").each(function () {
            var flat_id = parseInt($(this).data("floor_num"));
            var ddata = JSON.parse(
              '{"floor": "' +
                flat_id +
                '", "flats": "' +
                (floor_cnt[flat_id] ? floor_cnt[flat_id] : 0) +
                '"}'
            );

            $(this)
              .data("floor", ddata)
              .prop("data-floor", ddata)
              .attr("data-floor", ddata);

            if (ids.indexOf(flat_id) >= 0) {
              if (!$(this).hasClass("Genplan_poligonLink-filtered"))
                $(this).addClass("Genplan_poligonLink-filtered");
            } else $(this).removeClass("Genplan_poligonLink-filtered");
          });

          var $scheme = $(".HouseFloor");

          //initTitle();

          var $title = $scheme.find("[data-floor]");
          var popupTpl = _.template(
            '<div class="infoTooltip" style="max-width: 164px; pointer-event:none;">\n\t\t\t\t\t<div class="infoTooltip_title"> <%= floor %> \u044D\u0442\u0430\u0436</div>\n\t\t\t\t\t<div class="infoTooltip_content"> <%= flats %> \u043A\u0432\u0430\u0440\u0442\u0438\u0440 </div>\n\t\t\t\t</div>'.replace(
              /\s{2,}/g,
              ""
            )
          );

          $scheme.tooltip({
            items: "[data-floor]",
            track: true,
            hide: { duration: 0 },
            show: { duration: 0 },
            content: function content() {
              var $el = $(this);
              var params = $el.data("floor");
              var dataToRender = {
                num: null,
                flats: null,
              };

              console.log(params);

              _.assignIn(dataToRender, params);
              return popupTpl(dataToRender, params);
            },
          });

          var $scheme = $(".HouseFloor");

          //initTitle();

          var $title = $scheme.find("[data-floor]");
          var popupTpl = _.template(
            '<div class="infoTooltip" style="max-width: 164px; pointer-event:none;">\n\t\t\t\t\t<div class="infoTooltip_title"> <%= floor %> \u044D\u0442\u0430\u0436</div>\n\t\t\t\t\t<div class="infoTooltip_content"> <%= flats %> \u043A\u0432\u0430\u0440\u0442\u0438\u0440 </div>\n\t\t\t\t</div>'.replace(
              /\s{2,}/g,
              ""
            )
          );

          $scheme.tooltip({
            items: "[data-floor]",
            track: true,
            hide: { duration: 0 },
            show: { duration: 0 },
            content: function content() {
              var $el = $(this);
              var params = $el.data("floor");
              var dataToRender = {
                num: null,
                flats: null,
              };

              console.log(params);

              _.assignIn(dataToRender, params);
              return popupTpl(dataToRender, params);
            },
          });

          return;
        } else if (jsonResponse.flat_ids) {
          console.log("floor flats..");

          var ids = jsonResponse.flat_ids;

          $(".BldScheme_link, .HouseSection_mobileCard").each(function () {
            var flat_id = parseInt($(this).attr("flat_id"));
            if (ids.indexOf(flat_id) >= 0) {
              $(this).show();
            } else $(this).hide();
          });

          return;
        }

        let filteredPlans = jsonResponse.objs;
        filteredPlans = _.each(filteredPlans, function (pln) {
          const flats = pln.flats;
          let areas = [];
          let prices = [];

          _.each(flats, (flat) => {
            areas.push(flat.area);
            prices.push(flat.price);
          });

          pln.areaMin = Math.min(...areas);
          pln.priceMin = Math.min(...prices);
        });

        {
          let urlSuffix = $.param(currentFiltersParams);

          _.forEach(filteredPlans, (plan) => {
            plan.href += "?" + urlSuffix;
          });
        }

        // fix pics urls in development enviroment
        if (window.location.href.indexOf("/filters.html") != -1) {
          console.warn("rewrite json response for dev enviroment usage...");
          filteredPlans.forEach((fltType) => {
            fltType.plan = "https://dom-rafinad.ru/" + fltType.plan;
            fltType.href = "/flat_type.html";
          });
          console.log("jsonResponse", jsonResponse);
        }

        filteredPlans = _.groupBy(filteredPlans, "rooms");

        if (!Object.keys(filteredPlans).length) {
          $("#filterResult").html(
            `<div class="NoPlansFound">
                            <div class="NoPlansFound_wrap">
                                <img class="NoPlansFound_img" src="/img/ui/not-found.png" alt=""/>
                                <p class="NoPlansFound_text">Планировки по заданным параметрам не найдены,<br class="hidden-xs"> пожалуйста измените параметры поиска.</p>
                                <a href="#" class="NoPlansFound_reset">Сбросить фильтр</a>
                            </div>
                        </div>`
          );
        } else {
          let dataToRender = {
            plans: filteredPlans,
            promos: jsonResponse.promos,
          };

          $("#filterResult").html(plansListBuilder.renderCards(dataToRender));
        }
      })
      .fail(() => {
        alert("Не удалось получить данные с сервера!\nПопробуйте позже.");
      });
  },
});

$(".FilterForm_label-accord").on("click", function () {
  $(this).toggleClass("FilterForm_label-accordActive");
  $(this).siblings(".FilterForm_chksOtherGroup").slideToggle(300);
});

$("#filterResult").on("click", function (event) {
  const $target = $(event.target);

  if ($target.hasClass("NoPlansFound_reset")) {
    event.preventDefault();

    $(".FilterSidebar_reset").trigger("click");
  }
});

$(".TurnButton, .FilterPage_flatParamsTopLink-navigate").on(
  "click",
  function (e) {
    $(".TurnButton").toggleClass("TurnButton-on");

    e.preventDefault();

    var href = $(this).attr("href"),
      timeout = 700;

    setTimeout(function () {
      location.href = href;
    }, timeout);
  }
);

let isRadioCorpus = false;
let CorpusSchemeTrigger = {
  init: function () {
    const $item = $(".HousesScheme_bld");
    const $checkbox = $(".CustomCheckbox").find('[name="corpus[]"]');

    console.log("chk_l=" + $checkbox.length);

    if ($checkbox.length)
      /* эта проверка нужна для страницы  корпуса, чтобы перехзодить на старницу выбранного корпуса*/
      $item.on("click", function (e) {
        const $data = $(e.currentTarget).data("triggercorpus");
        e.preventDefault();
        if (isRadioCorpus) {
          $item.removeClass("HousesScheme_bld-active");
        }
        $checkbox.each((i, e) => {
          if ($(e).data(`persist-id`) === $data) {
            $(e).trigger("click");

            if ($(e).is(":checked")) {
              $(e.currentTarget).addClass("HousesScheme_bld-active");
            } else {
              $(e.currentTarget).removeClass("HousesScheme_bld-active");
            }
          }
        });
      });

    $checkbox.on("change", function () {
      const data = $(this).data("persist-id");

      if (isRadioCorpus) {
        $item.removeClass("HousesScheme_bld-active");
      }

      if ($(this).is(":checked")) {
        $(`[data-triggercorpus=${data}]`).addClass("HousesScheme_bld-active");
      } else {
        $(`[data-triggercorpus=${data}]`).removeClass(
          "HousesScheme_bld-active"
        );
      }
    });

    $(window).on("load", function () {
      if (isRadioCorpus) {
        $checkbox.find('[data-persist-id = "corpus_1"]').trigger("click");
      }

      $checkbox.each((i, e) => {
        if ($(e).is(":checked")) {
          const data = $(e).data("persist-id");

          $(`[data-triggercorpus=${data}]`).addClass("HousesScheme_bld-active");
        }
      });
    });
  },

  reset: function () {
    const $item = $(".HousesScheme_bld");
    const $checkbox = $(".CustomCheckbox").find('[name="corpus[]"]');

    if (isRadioCorpus) {
      $checkbox.find('[data-persist-id = "corpus_1"]').trigger("click");

      $checkbox.each((i, e) => {
        if ($(e).is(":checked")) {
          const data = $(e).data("persist-id");
          $item.removeClass("HousesScheme_bld-active");
          $(`[data-triggercorpus=${data}]`).addClass("HousesScheme_bld-active");
        }
      });
    }

    if (!isRadioCorpus) {
      $item.removeClass("HousesScheme_bld-active");
    }
  },
};

CorpusSchemeTrigger.init();
